import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dummy",
  "use": "icon-dummy-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol viewBox=\"0 0 21 21\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dummy\">\r\n    <circle cx=\"10.5\" cy=\"10.5\" r=\"10.5\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol